import React from "react";
import { motion } from "framer-motion";
import {
  Sprout, Bot, School, GraduationCap, BookOpen, Users, Globe,
  Lightbulb, Trophy, LayoutDashboard, BookMarked, Microscope,
  Monitor, Target, BarChart2, ClipboardList, Languages,
  Dumbbell, Gamepad2, Heart,
} from "lucide-react";
import "./Projects.scss";

import com1  from "../assets/Our-projects/nurture programme.webp";
import com2  from "../assets/Our-projects/ai-for-all.webp";
import com3  from "../assets/Our-projects/pm shri schools.webp";
import com4  from "../assets/Our-projects/dehradun officer training .webp";
import com5  from "../assets/Our-projects/dehradun c meet training .webp";
import com6  from "../assets/Our-projects/youth-skilling.webp";
import com7  from "../assets/Our-projects/nuture programme 2.webp";
import com8  from "../assets/Our-projects/ai-thinktank.webp";
import com9  from "../assets/Our-projects/AI Vidya Setu Logo 1.webp";
import com10 from "../assets/Our-projects/vr for school .webp";

import pMedha    from "../assets/medha-slide-4.png";
import pLms      from "../assets/key-offerings/school2.webp";
import pGyan     from "../assets/key-offerings/school1.webp";
import pAtlGyan  from "../assets/innovation/skill-development.webp";
import pSkiksha  from "../assets/innovation/smart-classes.webp";
import pSankalp  from "../assets/testimonials/sankalp image.png";
import pScore    from "../assets/medha-slide-6.png";
import pTtms     from "../assets/nextgen/ng-lab-4.jpeg";
import pKvtt     from "../assets/Our-projects/dehradun officer training .webp";
import pAnuwad   from "../assets/nextgen/ng-lab-9.jpg";
import pSports   from "../assets/key-offerings/cs-1.webp";
import pKhelo    from "../assets/Our-projects/vr for school .webp";
import pUdhan    from "../assets/nextgen/ng-lab-6.jpg";
import pAtlPpt   from "../assets/Our-projects/ai-thinktank.webp";
import pIncub    from "../assets/testimonials/cograd incubation program.png";
import pNextgen  from "../assets/nextgen/ng-hero.jpg";

import logo1 from "../assets/partners/l-ihfc.webp";
import logo2 from "../assets/partners/l-adobe.webp";
import logo3 from "../assets/partners/l-pmshree_11zon.webp";
import logo4 from "../assets/partners/l-siemt_11zon.webp";
import logo5 from "../assets/partners/l-ukEd.webp";
import logo6 from "../assets/partners/l-nasscom.webp";
import logo7 from "../assets/partners/l-thingqbator.webp";
import logo8 from "../assets/partners/l-fitt-iid_11zon.webp";
import logo9 from "../assets/partners/l-kvs.webp";

const PROJECTS = [
  { id: 1,  icon: Sprout,        image: com1, logo: logo1, title: "Nurture Programme",             desc: "Empowering rural students through hands-on learning in Emerging Technologies and personalised mentoring to foster future-ready talent." },
  { id: 2,  icon: Bot,           image: com2, logo: logo2, title: "Adobe AI for All",              desc: "Built Medha — an AI-powered platform helping teachers create personalised learning experiences for every student in India." },
  { id: 3,  icon: School,        image: com3, logo: logo3, title: "PM SHRI Schools",               desc: "Supporting PM SHRI schools in fostering quality education, innovation, and holistic student development across India." },
  { id: 4,  icon: GraduationCap, image: com4, logo: logo4, title: "Educational Officers Training", desc: "Training Block Education Officers in Uttarakhand on Generative AI and innovative education strategies." },
  { id: 5,  icon: BookOpen,      image: com5, logo: logo5, title: "Teachers Training",             desc: "Equipping educators with AI, coding, and emerging tech skills to transform classrooms across Uttarakhand." },
  { id: 6,  icon: Users,         image: com6, logo: logo6, title: "Youth Skilling Programme",      desc: "Trained 5,000 young individuals in Data Science, AI, and emerging technologies in collaboration with NASSCOM." },
  { id: 7,  icon: Globe,         image: com7, logo: logo7, title: "Thingqbator Community",         desc: "Onboarded 20,000+ students on Cisco Thingqbator portal with lifetime free access to new-gen tech courses." },
  { id: 8,  icon: Lightbulb,     image: com8, logo: logo8, title: "AI Education ThinkTank",        desc: "Organised at IIT Delhi to solve education challenges through AI products and next-generation tools." },
  { id: 9,  icon: Trophy,        image: com9, logo: logo9, title: "AI Vidya Setu",                 desc: "National hackathon for KVS students (Grades 8–12) to solve real-world challenges through AI and innovation." },
  { id: 13, icon: Microscope,     image: pAtlGyan,title: "ATL GyanShakti",   desc: "Specialised edition for Atal Tinkering Lab schools focused on innovation, tinkering, and STEM." },
  { id: 15, icon: Target,         image: pSankalp,title: "Sankalp",          desc: "A National Summit on Innovation & Skills empowering students and young innovators to build real-world solutions.", href: "https://sankalp2026.com/", imgPos: "center top" },
  { id: 18, icon: GraduationCap,  image: pKvtt,   title: "KVTT",             desc: "Dedicated portal supporting Kendriya Vidyalaya teacher training — onboarding, sessions, and progress tracking." },
  { id: 23, icon: BookOpen,       image: pAtlPpt, title: "ATL PPT",          desc: "Presentation toolkit helping ATL educators deliver activity-based sessions effortlessly." },
  { id: 24, icon: Lightbulb,     image: pIncub,  title: "CoGrad Incubation", desc: "Supporting edtech startups with mentorship, funding access, and IIT Delhi network to build the future of education.", href: "/incubation" },
  { id: 25, icon: School,        image: pNextgen,title: "NextGen School",    desc: "Transforming government schools into innovation hubs with robotics, AI labs, and hands-on STEM programmes.", href: "/next-gen-school" },
];

function Card({ p }) {
  const Icon = p.icon;
  const Wrapper = p.href ? "a" : "div";
  const wrapperProps = p.href ? { href: p.href, target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <Wrapper className="proj__card" {...wrapperProps}>
      {/* image or gradient */}
      <div className="proj__img-wrap">
        {p.image ? (
          <img src={p.image} alt={p.title} className="proj__img" style={p.imgPos ? { objectPosition: p.imgPos } : undefined} />
        ) : (
          <div className="proj__grad" style={{ background: p.grad }}>
            <Icon size={44} strokeWidth={1.2} />
          </div>
        )}
      </div>


      <div className="proj__body">
        <h3 className="proj__title">{p.title}</h3>
        <div className="proj__dash" />
        <p className="proj__desc">{p.desc}</p>

        {p.logo && (
          <div className="proj__assoc">
            <span className="proj__assoc-label">In association with</span>
            <img src={p.logo} alt="" className="proj__assoc-logo" />
          </div>
        )}
      </div>
    </Wrapper>
  );
}

export default function Projects() {
  const doubled = [...PROJECTS, ...PROJECTS];

  return (
    <section className="proj-wrap">
      <div className="proj-inner">
        <motion.div
          className="proj__top"
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="proj__chip">✦ KEY INITIATIVES</div>
          <h2 className="proj__h2">Our <span>Projects</span></h2>
          <div className="proj__head-rule" />
          <p className="proj__sub">
            Explore our key initiatives that are transforming education through<br />
            innovation, technology, and capacity building.
          </p>
        </motion.div>
      </div>

      {/* single auto-scroll row */}
      <div className="proj__row">
        <div className="proj__track">
          {doubled.map((p, i) => <Card key={i} p={p} />)}
        </div>
      </div>


    </section>
  );
}
